import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PurchaseSection() {
  return <section id="compra" className="py-6 md:py-12 px-3 bg-brand-card scroll-mt-10" data-id="element-251">
      <div className="max-w-3xl mx-auto" data-id="element-252">
        <div className="text-center mb-5" data-id="element-253">
          <div className="inline-block bg-brand-accent/20 text-brand-accent font-black px-4 py-1.5 rounded-full mb-3 border-2 border-brand-accent animate-pulse text-xs md:text-sm tracking-wide" data-id="element-254">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>

          <div className="mb-3" data-id="element-255">
            <CountdownTimer data-id="element-256" />
          </div>

          <p className="text-xs md:text-base font-bold text-gray-300 mb-3" data-id="element-257">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-xs mx-auto bg-brand-dark p-2.5 rounded-lg border border-white/10" data-id="element-258">
            <div className="flex justify-between text-[10px] md:text-xs font-bold mb-1.5" data-id="element-259">
              <span className="flex items-center text-red-500" data-id="element-260">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500 mr-1.5 animate-ping" data-id="element-261"></span>
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-gray-400" data-id="element-262">Quedan pocos</span>
            </div>
            <div className="w-full bg-gray-800 rounded-full h-2 mb-1 overflow-hidden" data-id="element-263">
              <div className="bg-red-500 h-2 rounded-full w-[78%]" data-id="element-264"></div>
            </div>
            <p className="text-[9px] text-gray-500 text-right font-bold" data-id="element-265">
              78% de los cupos tomados
            </p>
          </div>
        </div>

        <h2 className="text-xl md:text-3xl font-black text-center mb-5 text-white" data-id="element-266">
          💰 ELEGÍ TU KIT
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-267">
          {/* Basic Kit */}
          <div className="bg-brand-dark rounded-xl border border-white/10 p-4 md:p-5 flex flex-col relative" data-id="element-268">
            <div className="mb-3" data-id="element-269">
              <h3 className="text-base md:text-lg font-black text-white mb-1 flex items-center" data-id="element-270">
                <span className="text-xl mr-2" data-id="element-271">📘</span> KIT PROGRAMACIÓN
                TÉCNICA LISTA
              </h3>
              <p className="text-brand-accent font-black text-sm" data-id="element-272">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="bg-brand-card p-2.5 rounded-lg mb-4 border border-white/5" data-id="element-273">
              <p className="text-[10px] md:text-xs text-gray-300 font-medium" data-id="element-274">
                <span className="font-black text-white" data-id="element-275">Ideal para:</span>{' '}
                Docentes que quieren el año de programación resuelto
              </p>
            </div>

            <div className="mb-4 flex-grow" data-id="element-276">
              <div className="flex flex-col items-center justify-center" data-id="element-277">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-278">
                  $45.000 ARS
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-279">
                  $19.990 <span className="text-base text-gray-400" data-id="element-280">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47940574347502:1" className="py-3 text-sm md:text-base" pulse={false} data-id="element-281">
              → QUIERO MI KIT AHORA
            </Button>
          </div>

          {/* Premium Kit */}
          <div className="bg-brand-dark rounded-xl border-2 border-brand-accent p-4 md:p-5 flex flex-col relative transform md:-translate-y-2 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-282">
            <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 bg-brand-accent text-white font-black px-4 py-1 rounded-full text-[10px] tracking-widest shadow-lg whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-283">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-3 mt-2" data-id="element-284">
              <h3 className="text-base md:text-lg font-black text-white mb-1 flex items-start" data-id="element-285">
                <span className="text-xl mr-2" data-id="element-286">🏆</span>
                <span data-id="element-287">KIT COMPLETO + UPSELL PREMIUM ⭐</span>
              </h3>
              <p className="text-brand-accent font-black text-sm" data-id="element-288">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="bg-brand-accent/10 p-2.5 rounded-lg mb-4 border border-brand-accent/30" data-id="element-289">
              <p className="text-[10px] md:text-xs text-gray-200 font-medium" data-id="element-290">
                <span className="font-black text-white" data-id="element-291">Ideal para:</span>{' '}
                Docentes que quieren llevar a sus alumnos al siguiente nivel
                real
              </p>
            </div>

            <div className="mb-4 flex-grow" data-id="element-292">
              <div className="flex flex-col items-center justify-center" data-id="element-293">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-294">
                  $63.000 ARS
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-295">
                  $27.990{' '}
                  <span className="text-base text-brand-accent/70" data-id="element-296">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47940575199470:1" className="py-3 md:py-4 text-sm md:text-lg" pulse={true} data-id="element-297">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>
        </div>
      </div>
    </section>;
}